import {gsap} from 'gsap'
import 'pace-js'
import {runIntroAnimations} from '../animations/intro'
import Lottie from 'lottie-web'

// The overlay is released once the logo has played, Pace reports the page as
// loaded and window load has fired. MAX_PRELOADER_TIME is the hard ceiling, so a
// stalled asset or a missing animation file can never leave the overlay up.
const MAX_PRELOADER_TIME = 8000
const LOGO_START_FALLBACK = 600

let pageLoaded = false
let windowLoaded = document.readyState === 'complete'
let animationFinished = false
let animationIsPlaying = false
let animationReady = false
let playRequested = false
let preloaderLottie = null
let animation = null
let paceLagCounter = 10
let preloaderAnimationExecuted = 0
window.onbeforeunload = renderLoading;

function renderLoading() {
  Pace.stop();
  //Pace.start();
  Pace.bar.render();
}

setTimeout(function () {
  // Bugfix for too fast loading (browser cache)
  if (Pace.bar.progress >= 100 || Pace.bar.progress === 0) {
    const rndInt = Math.floor(Math.random() * (39 - 10 + 1) + 10)
    paceUpdate(rndInt)
  }
}, 50)

$(window).on('load', function () {
  windowLoaded = true
  runPreloaderAnimation()
})

setTimeout(function () {
  pageLoaded = true
  windowLoaded = true
  animationFinished = true
  runPreloaderAnimation()
}, MAX_PRELOADER_TIME)

function runPreloaderAnimation() {
  if (preloaderAnimationExecuted) {
    return false
  }
  if (!pageLoaded || !windowLoaded || !animationFinished) {
    return false
  }


  setTimeout(function () {
    gsap.fromTo('#preloader', {
      yPercent: 0
    }, {
      yPercent: -100,
      duration: 1,
      onComplete: () => {
        $('#preloader').hide()
        if (typeof window.updateLocoScroll === 'function') {
          window.updateLocoScroll()
        }
      }
    })
  }, 200)

  setTimeout(function () {
    runIntroAnimations()
  }, 750)

  preloaderAnimationExecuted = 1;

}


function playLogoAnimation() {
  playRequested = true

  if (animationIsPlaying || !animationReady) {
    return
  }

  animationIsPlaying = true
  $('.preloader-logo').css('opacity', 1)
  animation.play()
}


function setupLottie(preloaderLottie) {
  let path = preloaderLottie.attr('data-animation-path')
  let introId = 'preloader-animation'

  let svgContainer = document.getElementById(introId)

  animation = Lottie.loadAnimation({
    container: svgContainer,
    animType: 'svg',
    loop: false,
    autoplay: false,
    path: path
  });

  animation.addEventListener('DOMLoaded', function () {
    animationReady = true
    if (playRequested) {
      playLogoAnimation()
    }
  })

  animation.addEventListener('complete', animationDone);
  animation.addEventListener('data_failed', animationDone);

  // Cached loads can settle before Pace ever reports past 40%
  setTimeout(playLogoAnimation, LOGO_START_FALLBACK)

  function animationDone() {
    animationFinished = true
    runPreloaderAnimation()
  }
}

Pace.bar.update = function (progress) {
  Pace.trigger('update', progress)
  this.progress = progress;
  return this.render();
} // override update func to trigger 'update' event

function paceUpdate(percent) {
  if (!preloaderLottie) {
    preloaderLottie = $('#preloader-animation')
    setupLottie(preloaderLottie)
  }

  if (percent > 40) {
    playLogoAnimation()
  }

  if (percent > 10) {
    $('.js-percentage').html(Math.ceil(percent) + ' %')
  }

  if (percent > 99) {
    paceLagCounter -= 1
    if (paceLagCounter <= 0) {
      Pace.stop()
      pageLoaded = true
      runPreloaderAnimation()
    }
  }
}

Pace.on("update", function (percent) {
  paceUpdate(percent)
});

Pace.on('done', function () {
  $('.js-percentage').html('100 %')
  pageLoaded = true
  playLogoAnimation()
  runPreloaderAnimation()

})

Pace.start()
